import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/settings/')({
  component: () => <Navigate from="/workspaces/$workspaceId/bots/$botId/settings/" to="./general" />,
})
